import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "../../../../src/actions/actionCreators/httpActions";
import { showError } from "../../../../src/actions/actionCreators/snackbarActions";

function loadFoldersSuccess() {
  return { type: actionTypes.LOAD_FOLDER_SUCCESS };
}

export function loadFolders(queryString) {
  return async dispatch => {
    try {
      const folders = await dispatch(sendHttpRequest(api.getAllFolders(queryString)));
      dispatch(loadFoldersSuccess());

      return folders;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function exportFolders(filters, fieldsToShow) {
  return dispatch => {
    return api.exportFolders(filters, fieldsToShow).catch(err => {
      dispatch(showError(err.message));
      throw err;
    });
  };
}

export function buildFolderExportDownloadUrl(filePath, fileName) {
  return () => api.buildFolderExportDownloadUrl(filePath, fileName);
}

export function loadFolderUserPreferences() {
  return async (dispatch, getState) => {
    try {
      let allUserPreferences = getState().folderVisible.userPreferences;
      if (allUserPreferences.isLoaded) return;

      allUserPreferences = await dispatch(sendHttpRequest(api.loadUserPreferences()));
      dispatch({ type: actionTypes.LOAD_FOLDER_USER_PREFERENCES_SUCCESS, payload: allUserPreferences });

      const implicitPreference = allUserPreferences.find(x => x.implicit === true);
      dispatch({ type: actionTypes.LOAD_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS, payload: implicitPreference });

      const defaultPreference = allUserPreferences.find(x => x.isDefault === true);
      dispatch({ type: actionTypes.LOAD_FOLDER_DEFAULT_USER_PREFERENCE_SUCCESS, payload: defaultPreference });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateFolderUserPreferences(userPreferences) {
  return async dispatch => {
    try {
      await dispatch(sendHttpRequest(api.updateUserPreferences(userPreferences)));
      dispatch({ type: actionTypes.UPDATE_FOLDER_USER_PREFERENCES_SUCCESS, payload: userPreferences });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateFolderSelectedUserPreference(selectedUserPreference) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.UPDATE_FOLDER_SELECTED_USER_PREFERENCE_SUCCESS, payload: selectedUserPreference });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
